export const columns = [
    {
        label: window.$t('dashboard-bi::board-management::菜单名称'),
        prop: 'folderName',
        minWidth: '250px'
    },
    {
        label: window.$t('dashboard-bi::board-management::排序'),
        prop: 'position',
        minWidth: '100px'
    },
    {
        label: window.$t('dashboard-bi::board-management::类型'),
        prop: 'parentId',
        minWidth: '120px'
    },
    {
        label: window.$t('dashboard-bi::board-management::菜单类型'),
        prop: 'openType',
        minWidth: '150px'
    },
    {
        label: window.$t('dashboard-bi::board-management::打开方式'),
        prop: 'openTarget',
        minWidth: '120px'
    },
    {
        label: window.$t('dashboard-bi::board-management::可见'),
        prop: 'isHide',
        minWidth: '100px'
    },
    {
        label: window.$t('dashboard-bi::board-management::操作'),
        prop: 'operate',
        fixed: 'right',
        width: '230px'
    },
]